import React from 'react'
import cn from 'classnames'
import iconStyles from 'components/shared/icons/icons.module.scss'
import { Share2 } from 'lucide-react'

export default function ClipIcon(props) {
    const { contextStyles, hoverStyles, selectedStyles } = props
    return (
        <div
            className={cn(
                iconStyles.iconComp,
                iconStyles.fontIconComp,
                contextStyles,
                hoverStyles,
                selectedStyles,
            )}
        >
            <Share2 />
        </div>
    )
}
